import translations from './const/fr.json';

const fr = {
  translation: {
    ...translations
  }
}

export default fr;